import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index';
// import login from '@/components/login/index'
import home from '@/components/index/index'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      meta: {},
      component: home
    },
    {
      path: '*',
      component: home
    },
    {
      path: '/login/index',
      name: 'login',
      component: () => import('@/components/login/index')
    },
    {
      path: '/index/extension',
      name: 'extension',
      meta: {
        title: '推广'
      },
      component: () => import('@/components/index/extension')
    },
    {
      path: '/index/zf_zone',
      name: 'zf_zone',
      meta: {
        title: '专服绿色服推广'
      },
      component: () => import('@/components/index/zf_zone')
    },
    {
      path: '/index/datas',
      name: 'datas',
      meta: {
        title: '排名'
      },
      component: () => import('@/components/index/datas')
    },
    {
      path: '/index/my',
      name: 'my',
      meta: {
        title: '个人信息'
      },
      component: () => import('@/components/index/my')
    },
    {
      path: '/index/box',
      name: 'box',
      meta: {
        title: '盒子'
      },
      component: () => import('@/components/index/box')
    },
    {
      path: '/index/union_ball',
      name: 'unionBall',
      meta: {},
      component: () => import('@/components/index/union_ball')
    },
    {
      path: '/mine/charge_plat',
      name: 'platCharge',
      meta: {
        title: '平台币充值'
      },
      component: () => import('@/components/mine/charge_plat')
    },
    {
      path: '/home/active_search',
      name: 'activeSearch',
      meta: {
        title: '活动查询'
      },
      component: () => import('@/components/home/active_search')
    },
    {
      path: '/home/gift_search',
      name: 'giftSearch',
      meta: {
        title: '礼包查询'
      },
      component: () => import('@/components/home/gift_search')
    },
    {
      path: '/home/open_serve',
      name: 'openServe',
      meta: {
        title: '新游首发'
      },
      component: () => import('@/components/home/open_serve')
    },
    {
      path: '/home/recharge_list',
      name: 'rechargeList',
      meta: {},
      component: () => import('@/components/home/recharge_list')
    },
    {
      path: '/home/substitute',
      name: 'substitute',
      meta: {
        title: '会长代充'
      },
      component: () => import('@/components/home/substitute')
    },
    {
      path: '/home/today_new',
      name: 'todayNew',
      meta: {
        title: '新游首发'
      },
      component: () => import('@/components/home/today_new')
    },
    {
      path: '/home/user_list',
      name: 'userList',
      meta: {
        title: '玩家列表'
      },
      component: () => import('@/components/home/user_list')
    },
    {
      path: '/home/game_detail',
      name: 'gameDetail',
      component: () => import('@/components/home/game_detail')
    },
    {
      path: '/home/active_detail',
      name: 'activeDetail',
      meta: {
        title: '活动详情'
      },
      component: () => import('@/components/home/active_detail')
    },
    {
      path: '/home/sense_search',
      name: 'senseSearch',
      meta: {
        title: '归属查询'
      },
      component: () => import('@/components/home/sense_search')
    },
    {
      path: '/home/fish_search',
      name: 'fishSearch',
      meta: {
        title: '钓鱼查询'
      },
      component: () => import('@/components/home/fish_search')
    },
    {
      path: '/home/son_list',
      name: 'sonList',
      meta: {
        title: '子渠道列表'
      },
      component: () => import('@/components/home/son_list')
    },
    {
      path: '/mine/cash',
      name: 'cash',
      meta: {
        title: '余额提现'
      },
      component: () => import('@/components/mine/cash')
    },
    {
      path: '/mine/sum_list',
      name: 'sumList',
      meta: {
        title: '余额发布列表'
      },
      component: () => import('@/components/mine/sum_list')
    },
    {
      path: '/mine/money_buy_record',
      name: 'moneyBuyRecord',
      meta: {
        title: '余额购买记录'
      },
      component: () => import('@/components/mine/money_buy_record')
    },
    {
      path: '/mine/plat_move',
      name: 'platMove',
      meta: {
        title: '平台币转移'
      },
      component: () => import('@/components/mine/plat_move')
    },
    {
      path: '/mine/charge_deposit',
      name: 'chargeDeposit',
      meta: {
        title: '缴纳押金'
      },
      component: () => import('@/components/mine/charge_deposit')
    },
    {
      path: '/mine/three_game',
      name: 'threeGame',
      meta: {
        title: '第三方游戏'
      },
      component: () => import('@/components/mine/three_game'),
      beforeEnter: (to, from, next) => {
        let userObj = store.state.userInfo
        if (userObj.is_third_game == 0) {
          next(from.fullPath)
        } else {
          next()
        }
      }
    },
    // {
    //   path: '/home/bu_dot',
    //   name: 'buDot',
    //   meta: {
    //     title: '游戏补点'
    //   },
    //   component: () => import('@/components/home/bu_dot')
    // },
    // {
    //   path: '/home/dot_recored',
    //   name: 'dotRecored',
    //   meta: {
    //     title: '补点记录'
    //   },
    //   component: () => import('@/components/home/dot_recored')
    // },
    {
      path: '/discount',
      name: 'discount',
      component: () => import('@/components/discount/index')
    },
    {
      path: '/home/substitute_recored',
      name: 'substituteRecored',
      meta: {
        title: '代充记录'
      },
      component: () => import('@/components/home/substitute_recored')
    },
    {
      path: '/mine/commission_detail',
      name: 'commissionDetail',
      meta: {
        title: ''
      },
      component: () => import('@/components/mine/commission_detail')
    },
    {
      path: '/home/lower_cash',
      name: 'lowerCash',
      meta: {
        title: '下级提现'
      },
      component: () => import('@/components/home/lower_cash')
    },
    {
      path: '/down/index',
      name: 'BoxRegister',
      component: () => import('@/components/down/index')
    },
    {
      path: '/home/lower_final',
      name: 'lowerFinal',
      meta: {
        title: '下级结算'
      },
      component: () => import('@/components/home/lower_final')
    },
    {
      path: '/home/final_total',
      name: 'finalTotal',
      meta: {
        title: '结算汇总'
      },
      component: () => import('@/components/home/final_total')
    },
    {
      path: '/mine/problem',
      name: 'problem',
      meta: {
        title: '常见问题'
      },
      component: () => import('@/components/mine/problem')
    },
    {
      path: '/mine/playerplat_list',
      name: 'playerplatList',
      meta: {
        title: '平台币代充记录'
      },
      component: () => import('@/components/mine/playerplat_list')
    },
    {
      path: '/home/back_recored',
      name: 'backRecored',
      meta: {
        title: '后台发放记录'
      },
      component: () => import('@/components/home/back_recored'),
      beforeEnter: (to, from, next) => {
        let userObj = store.state.userInfo
        if (userObj.is_admin < 1) {
          next(from.fullPath)
        } else {
          next()
        }
      }
    },
    {
      path: '/home/promote_recored',
      name: 'promoteRecored',
      meta: {
        title: '渠道发放记录'
      },
      component: () => import('@/components/home/promote_recored'),
      beforeEnter: (to, from, next) => {
        let userObj = store.state.userInfo
        if (userObj.is_admin != 2) {
          next(from.fullPath)
        } else {
          next()
        }
      }
    },
    {
      path: '/home/user_recored',
      name: 'userRecored',
      meta: {
        title: '玩家登录记录'
      },
      component: () => import('@/components/home/user_recored')
    },
    {
      path: '/home/analyse',
      name: 'analyse',
      meta: {
        title: '留存分析'
      },
      component: () => import('@/components/home/analyse')
    },
    {
      path: '/home/charge_top',
      name: 'chargeTop',
      meta: {
        title: '0.1折排行'
      },
      component: () => import('@/components/home/charge_top')
    },
    {
      path: '/mine/substitute_back',
      name: 'substituteBack',
      meta: {
        title: '平台币收回'
      },
      component: () => import('@/components/mine/substitute_back')
    },
    {
      path: '/index/oem',
      name: 'oem',
      meta: {
        title: '品牌打造'
      },
      component: () => import('@/components/index/oem'),
      beforeEnter: (to, from, next) => {
        let userObj = store.state.userInfo
        if (userObj.promote_level > 1) {
          next(from.fullPath)
        } else {
          next()
        }
      }
    }
    // {
    //   path: '/mine/sell',
    //   name: 'sell',
    //   meta: {
    //     title: '佣金寄售'
    //   },
    //   component: () => import('@/components/mine/sell')
    // },
    // {
    //   path: '/mine/sell_list',
    //   name: 'sell_list',
    //   meta: {
    //     title: '佣金发布记录'
    //   },
    //   component: () => import('@/components/mine/sell_list')
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js